import { getEdmQuery, getEdmQueryCount, setEdmQueryResult } from '@/services/edm'
const state = {
  loading: true,
  filterAllData: {},
  filterFormData: [],
  filterResult: {},
  filterStr: '',
  filterSort: []
}

const getters = {
}

const mutations = {
  GET_QUERY (state, data = {}) {
    const { allconfig = {}, config = {} } = data
    // 过滤原始数据
    for (let k in allconfig) {
      if (allconfig[k].child.length === 0) {
        delete allconfig[k]
      }
    }
    state.filterAllData = allconfig
    state.filterFormData = config
    state.filterSort = config
  },
  SET_CONFIG (state, newConfigKey = []) {
    if (newConfigKey.length) {
      state.filterFormData = []
      for (let key of newConfigKey) {
        for (let i in state.filterAllData) {
          let child = state.filterAllData[i] && state.filterAllData[i].child
          for (let j in child) {
            let item = child[j]
            item.checked = false
            item.ischecked = 1
            if (key === item.fieldkey) {
              item.checked = true
              item.ischecked = 1
              state.filterFormData.push(item)
            }
          }
        }
      }
    }
  },
  SET_LOADING (state, data) {
    state.loading = data
  },
  SET_FILTER_RESULT (state, data) {
    state.filterResult = data
  },
  SET_FILTER_STR (state, data) {
    state.filterStr = data
  },
  SET_FILTER_SORT (state, data) {
    state.filterSort = data
  }
}

const actions = {
  async fetchQuery ({ commit }) {
    commit('SET_LOADING', true)
    const chain = await getEdmQuery()
    chain
      .onSuccess(async payload => {
        commit('GET_QUERY', payload)
        commit('SET_LOADING', false)
      })
      .onFail(_ => {
        commit('SET_LOADING', false)
      })
      .fetch()
    return chain
  },
  async fetchEdmQueryCount ({ commit }, params) {
    const chain = await getEdmQueryCount()
    chain
      .params(params)
      .onSuccess(async payload => {
        commit('GET_QUERY', payload)
      })
      .fetch()
    return chain
  },
  setFilterResult ({ commit }, data) {
    commit('SET_FILTER_RESULT', data)
  },
  setFilterStr ({ commit }, data) {
    commit('SET_FILTER_STR', data)
  },
  async setEdmQueryResult ({ commit }, params) {
    const chain = await setEdmQueryResult()
    chain
      .params(params)
      .fetch()
    return chain
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
